module.exports = __webpack_public_path__ + "static/media/firework_1.8e03abbf.mp3";


//////////////////
// WEBPACK FOOTER
// ./src/static/audio/firework_1.mp3
// module id = 531
// module chunks = 0